<app-loader></app-loader>
<div class="offer-model" [formGroup]="CheckCouponValidityForm">
    <div class="top-heading">
        <div class="offer-heading">
            <h4>Offers</h4>
        </div>

        <div class="close-icon">
            <img src="assets/images/export-close.svg" (click)="closeDialog()" alt="Close"/>
        </div>
    </div>         
    <div class="offer-apply">
        <div class="apply-inner">  
            <input pInputText placeholder type="text" placeholder="Enter Promo code" formControlName="couponCode"/>
            <h4 (click)="checkCouponValidity()">Apply</h4>
        
        </div>
        <div *ngIf="showCouponError && CheckCouponValidityForm.get('couponCode').errors && CheckCouponValidityForm.get('couponCode').touched" class="text-danger">
            <div  class="validation-error" *ngIf="CheckCouponValidityForm.get('couponCode').hasError('required')">Coupon code is required</div>
        </div>
            <p *ngIf="availableOffers?.afterApplyOffer !=undefined">Explore Offers</p>
        <p *ngIf="errorMessage" class="text-center">{{errorMessage}}</p>
        <p *ngIf="availableOffers?.availableOffer.length == 0" class="text-center">No Active Offers</p>
        <p *ngIf="availableOffers?.availableOffer.length > 0" class="avail-offers">Available Offers</p>
    </div>
    <div class="box-outer" *ngFor="let offer of availableOffers?.availableOffer">
        <div class="single-boxes">
            <div class="blue-strip">
                <div class="my-icon" aria-label="My icon" [inlineSVG]="'assets/images/off.svg'"></div>
                <h3>{{offer?.verticalLabel}}</h3>
            </div>
            <div class="coupon-outer">
                <div class="coupon-outers">
                    <div class="left-coupan">
                <h2>COUPON - {{offer?.couponCode}}</h2>
                <div class="check">
                    <div class="my-icon" aria-label="My icon" [inlineSVG]="'assets/images/checked.svg'"></div>
                    <span>{{offer?.summary}}</span>
                </div>
                </div>
                <div class="right-coupan">
   
                    <p-button label="Apply" *ngIf="offer.redeemStatus != 1" (onClick)="applyOffer(offer)"></p-button>
                    <p-button label="Redeem" *ngIf="offer.redeemStatus === 1" (onClick)="applyOffer(offer)"></p-button>

                </div>
            </div>
                <p>{{offer?.description}}</p>
                <div class="apply-outer">
                    <div class="expire-date">
                        <h4 *ngIf="offer?.endDate !=0">Expires on {{offer?.endDate | customDate}}</h4>
                    </div>
                
                </div>
            </div>
        </div>
    </div>

</div>